// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"13c35399f13e28d72ff9","532":"ab9de084517b84ef8c04","691":"16ceff93c96fb8eb83d8"}[chunkId] + ".js";
};